const decodeBase64Url = (value) => {
  const normalized = value.replace(/-/g, '+').replace(/_/g, '/');
  const padded = normalized.padEnd(Math.ceil(normalized.length / 4) * 4, '=');
  return atob(padded);
};

export const parseJwt = (token) => {
  try {
    if (!token) return null;
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = decodeBase64Url(parts[1]);
    return JSON.parse(payload);
  } catch (error) {
    return null;
  }
};

export const extractUserFromToken = (token) => {
  const payload = parseJwt(token);
  if (!payload) return null;

  const roleClaim = payload.role || payload['http://schemas.microsoft.com/ws/2008/06/identity/claims/role'];
  const emailClaim = payload.email || payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/emailaddress'];
  const idClaim = payload.sub || payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier'];
  const nameClaim = payload.name || payload['http://schemas.xmlsoap.org/ws/2005/05/identity/claims/name'];

  return {
    id: idClaim ? Number(idClaim) : null,
    email: emailClaim || '',
    role: roleClaim || '',
    name: nameClaim || ''
  };
};

export const isTokenExpired = (token) => {
  const payload = parseJwt(token);
  if (!payload || !payload.exp) return false;
  const expiresAt = payload.exp * 1000;
  return Date.now() >= expiresAt;
};
